import axios from "axios";
import { getAuthToken } from "utils/auth_helpers";
import { BASE_URL, Map } from "utils/constants";

export const createLobby = ({
  name,
  password,
  ...options
}: {
  name: string;
  password?: string;
  boardName?: Map;
  venusActive?: boolean;
  allowReplayMode?: boolean;
}) => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.get["Content-Type"] = "application/json";
  axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`;

  return axios
    .post("/api/game-lobby/new", {
      name,
      password,
      ...options,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("Failure");
      console.log(err);
      return [];
    });
};
